import { UserThumbnailSize } from '@marketplace-web/profile/profile-data'

import { FeedbackUserDto, FeedbackUserModel } from '../types/feedback-user'

type UserPhotoThumbnailDto = {
  type: UserThumbnailSize
  url: string
}

type UserPhotoDto = {
  url: string
  thumbnails: Array<UserPhotoThumbnailDto>
}

type UserDto = {
  id: number
  photo: UserPhotoDto | null
  login: string
  profile_url: string
}

export const transformUser = (user?: FeedbackUserDto | UserDto): FeedbackUserModel | undefined => {
  if (!user) return undefined

  const photoUrl = 'photo' in user ? user.photo?.url : user.photo_url

  return {
    id: user.id,
    login: user.login,
    profileUrl: user.profile_url,
    photoUrl: photoUrl || undefined,
  }
}
